import React from 'react';
import { AlertTriangle, Clock, Wrench } from 'lucide-react';
export function PainSection() {
  const pains = [{
    icon: <AlertTriangle className="w-6 h-6 text-painBorder" data-id="element-126" />,
    title: 'Falla en plena operación',
    description: 'El montacargas se apaga, el depósito se paraliza y los pedidos se acumulan. Cada minuto sin operar es pérdida directa.'
  }, {
    icon: <Clock className="w-6 h-6 text-painBorder" data-id="element-127" />,
    title: 'Sin mantenimiento programado',
    description: 'Sin un plan preventivo, los equipos fallan sin avisar. Una revisión a tiempo vale diez veces menos que una reparación de emergencia.'
  }, {
    icon: <Wrench className="w-6 h-6 text-painBorder" data-id="element-128" />,
    title: 'Técnicos que no conocen la máquina',
    description: 'Kalmar, Hyster, Komatsu. Marcas exigentes que necesitan especialistas de verdad, no el primero que aparezca en Google.'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-129">
      <div className="container mx-auto px-4" data-id="element-130">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-131">
          <span className="inline-block px-4 py-1.5 rounded-full bg-badgeBg text-badgeText font-semibold text-sm mb-4" data-id="element-132">
            NO ES EL DAÑO ES
          </span>
          <h2 className="text-gray-900 font-heading font-bold" data-id="element-133">
            Cada hora parada es plata que se va
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-134">
          {pains.map((pain, index) => <div key={index} className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-135">
              {/* Left Orange Border */}
              <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-painBorder" data-id="element-136"></div>

              <div className="mb-6 p-3 bg-orange-50 inline-block rounded-lg" data-id="element-137">
                {pain.icon}
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-3 font-heading" data-id="element-138">
                {pain.title}
              </h3>

              <p className="text-gray-600 leading-relaxed" data-id="element-139">
                {pain.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}